import { LanguageKey, LanguageValue, Storage } from "@/shared/common/enums";
import type { IObject } from "@/shared/common/types";
import { getFromLocalStorage, getFromSessionStorage } from "@/shared/helpers/storageHelpers";

interface Props {
  [key: string]: string | number | undefined | boolean;
}

export const generateQuery = (data: Props) => {
  let query = "";
  for (const [key, value] of Object.entries(data)) {
    if (value && value !== "null") {
      if (query) {
        query += `&${key}=${value}`;
      } else {
        query += `${key}=${value}`;
      }
    }
  }
  return query;
};


export const withIdempotency = <T extends {
  data: unknown;
  idempotencyKey: string
  headers?: IObject
}>(url: string) => ({
  query: ({ data, idempotencyKey, headers }: T) => ({
    url,
    method: "POST",
    headers: { "Idempotency-Key": idempotencyKey, ...headers },
    data,
  }),
});

export const getEventStreamHeaders = () => {
  const lang = (getFromLocalStorage(Storage.Lang) || LanguageKey.Hy) as keyof typeof LanguageValue;
  const browserName = getFromSessionStorage(Storage.BrowserName);
  const browserVersion = getFromSessionStorage(Storage.BrowserVersion);
  const browserOs = getFromSessionStorage(Storage.BrowserOs);

  return {
    "Accept": "*/*",
    "Accept-Language": LanguageValue[lang],
    "Model": browserName || "",
    "DeviceOS": browserOs || "",
    "DeviceId": "MyAmeriaBusiness Web",
    "DeviceOSVersion": browserVersion || "",
    "Platform": "Web",
    "Content-Type": "text/event-stream",
  };
};
